const bindingCache = new WeakMap()

const EMPTY_OBJECT = Object.freeze({})

function getParametersCache(node) {
  let cache = bindingCache.get(node)
  if (!cache) {
    cache = new WeakMap()
    bindingCache.set(node, cache)
  }

  return cache
}

export function getTreeBindings(node, parameters, extraBindings) {
  if (!node) return extraBindings || EMPTY_OBJECT

  const normalizedParameters = parameters || EMPTY_OBJECT
  const cache = getParametersCache(node)
  const cached = cache.get(normalizedParameters)

  const sameExtraBindings = cached
    && cached.extraBindingsKeys.length === Object.keys(extraBindings || EMPTY_OBJECT).length
    && cached.extraBindingsKeys.every(key => cached.extraBindings[key] === (extraBindings || EMPTY_OBJECT)[key])

  if (cached && sameExtraBindings) {
    return cached.value
  }

  const value = Object.assign(
    {},
    extraBindings || EMPTY_OBJECT,
    node.propsData || EMPTY_OBJECT,
    normalizedParameters
  )

  cache.set(normalizedParameters, {
    extraBindings: extraBindings || EMPTY_OBJECT,
    extraBindingsKeys: Object.keys(extraBindings || EMPTY_OBJECT),
    value
  })
  return value
}
